import config from '../../config/config';

import getRequest from './base/get';
import patchRequest from './base/patch';

export default {
  /**
   * Fetch unapproved electricity price list
   */
  fetchUnapprovedElectricityPrice: (data: any) => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/electricity-price-history`, {
      ...data,
    });
  },
  /**
   * Function to fetch filters for electricity price
   */
  fetchUnapprovedElectricityPriceFilters: () => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1electricity-price-history`);
  },
  /**
   * API call to change the status of electricity price
   */
  updateStatusElectricityPriceHistory: (id: string, data: any) => {
    return patchRequest(
      `${config.commonApiUrl}api/super-admin/v1/electricity-price-history/${id}`,
      { ...data },
    );
  },
  /**
   * Unapproved Electricity PendingCount
   */
  fetchUnapprovedElectricityPendingCount:()=>{
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/electricity-price-history/pending-count`)
  }
};
